import { useState } from 'react'

import type { IntradayBidRow } from '~/pages/IntradayBidding/models/intradayBidRow'

/** 行の取消ボタンから開く取消確認 ([[IntradayWithdrawConfirmDialog]]) の開閉。 */
export type IntradayWithdrawConfirm = {
  /** 取消する札。 undefined の間は閉じている。 */
  target: IntradayBidRow | undefined
  /** 札の取消確認を開く。 */
  open: (row: IntradayBidRow) => void
  /** キャンセルで閉じる。 */
  close: () => void
  /**
   * 取消を受け付けた時、 送信時の対象 id の確認がまだ開いている時だけ閉じる。 RPC 解決までに
   * user が別行の取消確認へ開き直していた場合に、 遅れて返った成功で別の確認を閉じない。
   */
  closeIfStill: (targetId: string) => void
}

/**
 * 取消確認の開閉 (#10110)。 入札一覧 (`BidCreateTab`) と板情報の自社入札 (`MarketBoardTab`) が
 * それぞれ持ち、 [[IntradayWithdrawConfirmDialog]] に渡す (承認系の
 * `useIntradayApprovalDecision` + `IntradayApprovalDialogs` と同じ組み立て)。
 */
export const useIntradayWithdrawConfirm = (): IntradayWithdrawConfirm => {
  const [target, setTarget] = useState<IntradayBidRow | undefined>(undefined)
  return {
    target,
    open: setTarget,
    close: () => setTarget(undefined),
    closeIfStill: (targetId) =>
      setTarget((prev) => (prev?.id === targetId ? undefined : prev)),
  }
}
